import React, {useState, useEffect, useRef} from 'react';
import {shallowEqual, useSelector, useDispatch} from 'react-redux';

import {Form, Input, Select, Spin, Checkbox, InputNumber} from 'antd';
import {Modal, Button} from 'react-bootstrap';
import _ from 'lodash';
import {requestPOST} from 'src/utils/baseAPI';

import * as actionsModal from 'src/setup/redux/modal/Actions';
import * as actions from 'src/setup/redux/global/Actions';
import TDSelect from 'src/app/components/TDSelect';

const FormItem = Form.Item;

const ModalItem = (props) => {
  const dispatch = useDispatch();
  const modalVisible = useSelector((state) => state.modal.modalVisible);
  const [form] = Form.useForm();

  const [btnLoading, setBtnLoading] = useState(false);

  const handleCancel = () => {
    form.resetFields();
    dispatch(actionsModal.setModalVisible(false));
  };

  const onFinish = async () => {
    setBtnLoading(true);
    try {
      const values = await form.validateFields();
      const formData = form.getFieldsValue(true);
      const topic = (formData?.topicBegin ?? '') + (formData?.hardwaredeviceCode ?? '') + (formData?.topicEnd ?? '');
      formData.topic = topic;
      dispatch(actions.sub(formData));
      handleCancel();
    } catch (errorInfo) {
      setBtnLoading(false);
    }
    setBtnLoading(false);
  };

  return (
    <Modal
      fullscreen={'lg-down'}
      size='xl'
      show={modalVisible}
      onExited={handleCancel}
      keyboard={true}
      scrollable={true}
      onEscapeKeyDown={handleCancel}
    >
      <Modal.Header className='bg-primary px-4 py-3'>
        <Modal.Title className='text-white'>New Subscription</Modal.Title>
        <button type='button' className='btn-close btn-close-white' aria-label='Close' onClick={handleCancel}></button>
      </Modal.Header>
      <Modal.Body>
        <Form form={form} layout='vertical' /* initialValues={initData} */ autoComplete='off'>
          <div className='row'>
            <div className='col-xl-4 col-lg-4'>
              <FormItem label='Topic Begin' name='topicBegin' rules={[{required: true, message: 'Không được để trống!'}]}>
                <Input placeholder='' />
              </FormItem>
            </div>
            <div className='col-xxl-4 col-xl-3 col-lg-4'>
              <FormItem label='Thiết bị' name='hardwaredevice'>
                <TDSelect
                  showSearch={true}
                  reload={true}
                  placeholder='Thiết bị'
                  fetchOptions={async (keyword) => {
                    const res = await requestPOST(`api/v1/hardwaredevices/search`, {
                      pageNumber: 1,
                      pageSize: 10000,
                      keyword: keyword,
                    });
                    return res.data.map((item) => ({
                      ...item,
                      label: `${item.code}`,
                      value: item.code,
                    }));
                  }}
                  style={{
                    width: '100%',
                  }}
                  onChange={(value, current) => {
                    if (value) {
                      form.setFieldValue('hardwaredeviceCode', current?.code);
                    } else {
                      form.setFieldValue('hardwaredeviceCode', null);
                    }
                  }}
                />
              </FormItem>
            </div>
            <div className='col-xl-4 col-lg-4'>
              <FormItem label='Topic End' name='topicEnd'>
                <Input placeholder='' />
              </FormItem>
            </div>
            <div className='col-xl-12 col-lg-12'>
              <FormItem label='QoS' name='qos' rules={[{required: true, message: 'Không được để trống!'}]}>
                <Select
                  options={[
                    {
                      label: '0',
                      value: 0,
                    },
                    {
                      label: '1',
                      value: 1,
                    },
                    {
                      label: '2',
                      value: 2,
                    },
                  ]}
                />
              </FormItem>
            </div>
          </div>
        </Form>
      </Modal.Body>
      <Modal.Footer className='bg-light px-4 py-2 align-items-center'>
        <div className='d-flex justify-content-center  align-items-center'>
          <Button className='btn-sm btn-primary rounded-1 py-2 px-5  ms-2' onClick={onFinish} disabled={btnLoading}>
            <i className='fa fa-save'></i>
            {'Lưu'}
          </Button>
        </div>
        <div className='d-flex justify-content-center  align-items-center'>
          <Button className='btn-sm btn-secondary rounded-1 p-2  ms-2' onClick={handleCancel}>
            <i className='fa fa-times'></i>Đóng
          </Button>
        </div>
      </Modal.Footer>
    </Modal>
  );
};

export default ModalItem;
